import Vue from "vue";
import Router from "vue-router";
import AppLayout from "../components/admin/AppLayout";
import AuthLayout from "../components/auth/AuthLayout";
import lazyLoading from "./lazyLoading";

Vue.use(Router);
const base_url = "https://sistemamiranda.cl";
const demoRoutes = [];
if (process.env.NODE_ENV === "development") {
  const VueBook = require("vue-book");
  console.log('process.env.NODE_ENV === "development".True', process.env);
  demoRoutes.push(
    VueBook.createRoute({
      requireContext: require.context("./..", true, /.demo.vue$/),
      path: "/demo",
    }),
    VueBook.createRoute({
      requireContext: require.context("./../components", true, /.vue$/),
      path: "/presentation",
    })
  );

  Vue.use(VueBook.VueBookComponents);
}

const EmptyParentComponent = {
  template: "<router-view></router-view>",
};

export default new Router({
  routes: [
    ...demoRoutes,
    {
      path: "*",
      redirect: { name: "dashboard" },
    },
    {
      path: "/auth",
      component: AuthLayout,
      children: [
        {
          name: "reset-passwordV2",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/perfil/details`;
          },
        },
        {
          name: "login",
          path: "login",
          meta: {
            isPublic: true,
          },
          component: lazyLoading("auth/login/Login"),
        },
        {
          name: "signup",
          path: "signup",
          component: lazyLoading("auth/signup/Signup"),
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          path: "",
          redirect: { name: "login" },
        },
      ],
    },
    {
      path: "/404",
      component: EmptyParentComponent,
      children: [
        {
          name: "not-found-advanced",
          path: "not-found-advanced",
          component: lazyLoading("pages/404-pages/VuesticPageNotFoundSearch"),
        },
        {
          name: "not-found-simple",
          path: "not-found-simple",
          component: lazyLoading("pages/404-pages/VuesticPageNotFoundSimple"),
        },
        {
          name: "not-found-custom",
          path: "not-found-custom",
          component: lazyLoading("pages/404-pages/VuesticPageNotFoundCustom"),
        },
        {
          name: "not-found-large-text",
          path: "/pages/not-found-large-text",
          component: lazyLoading(
            "pages/404-pages/VuesticPageNotFoundLargeText"
          ),
        },
      ],
    },
    {
      name: "compras",
      path: "/compras",
      component: AppLayout,
      children: [
        {
          name: "ordenCompra",
          path: "orden-compra",
          component: lazyLoading("compra/Pages/ordenCompra"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "proveedores",
          path: "proveedores",
          component: lazyLoading("compra/Pages/proveedores"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "listar",
          path: "listar",
          component: lazyLoading("compra/Pages/listar"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "sugeridoCompra",
          path: "sugeridoCompra",
          component: lazyLoading("compra/Pages/sugeridoCompra"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "sugerido-compraV2",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/compras/sugerido-compra`;
          },
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "reporteInventario",
          path: "reporteInventario",
          component: lazyLoading("compra/Pages/reporteInventario"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "reportes",
          path: "reportes",
          component: lazyLoading("compra/Pages/reportes"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "transporte",
          path: "transporte",
          component: lazyLoading("compra/Pages/transporte"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
        {
          name: "productos",
          path: "productos",
          component: lazyLoading("compra/Pages/productos"),
          default: true,
          meta: {
            permissions: ["ADMIN", "COMPRAS"],
          },
        },
      ],
    },
    {
      name: "productoMiranda",
      path: "/producto",
      component: AppLayout,
      children: [
        {
          name: "producto",
          path: "productos",
          component: lazyLoading("Productos/Pages/productos"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "listarProductoMiranda",
          path: "listar-producto-miranda",
          component: lazyLoading("Productos/Pages/listarProductoMiranda"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "marcas",
          path: "marcas",
          component: lazyLoading("Productos/Pages/marcas"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "categoriaProducto",
          path: "categoria-producto",
          component: lazyLoading("Productos/Pages/categoriaProducto"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "clasificacionProducto",
          path: "clasificacion-producto",
          component: lazyLoading("Productos/Pages/clasificacionProducto"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "marcaProducto",
          path: "marca-producto",
          component: lazyLoading("Productos/Pages/marcaProducto"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "familiaProducto",
          path: "familia-producto",
          component: lazyLoading("Productos/Pages/familiaProducto"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "vehiculos",
          path: "vehiculos",
          component: lazyLoading("Productos/Pages/vehiculos"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "modelo",
          path: "modelo",
          component: lazyLoading("Productos/Pages/modelo"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "historico-productos",
          path: "historico-producto",
          component: lazyLoading("Productos/Pages/historicoProducto"),
          meta: {
            permissions: ["ADMIN", "PRODUCTO", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "sugerido-compra",
          path: "sugerido-compra",
          component: lazyLoading("compra/Pages/sugeridoCompra"),
          meta: {
            permissions: ["ADMIN"],
          },
        },
      ],
    },
    {
      name: "asociacionProducto",
      path: "/asociacion",
      component: AppLayout,
      children: [
        {
          name: "asociacion",
          path: "asociacion",
          component: lazyLoading("Asociacion/Pages/asociacion"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
        {
          name: "asociacionManual",
          path: "asociacion-manual",
          component: lazyLoading("Asociacion/Pages/asociacionManual"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
      ],
    },
    {
      name: "recepcionDocumento",
      path: "/recepcion",
      component: AppLayout,
      children: [
        {
          name: "recepcion",
          path: "recepcion",
          component: lazyLoading("Recepcion/Pages/recepcion"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
        {
          name: "documento",
          path: "documento",
          component: lazyLoading("Recepcion/Pages/documento"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION", "RECEPCION_GUIA"],
          },
        },
        {
          name: "listarDocumentosV2",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/reception/list-documents`;
          },
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
        {
          name: "listarDocumentosV2",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/reception/list-documents`;
          },
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
        {
          name: "crearDocumentos",
          path: "crear-documentos",
          component: lazyLoading("Recepcion/Pages/crearDocumentos"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
        {
          name: "nuevaRecepcion",
          path: "nueva-recepcion",
          component: lazyLoading("Recepcion/Pages/nuevaRecepcion"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
        {
          name: "recepcionGuia",
          path: "guia-traslado",
          component: lazyLoading("Recepcion/Pages/recepcionGuia"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION", "RECEPCION_GUIA"],
          },
        },
        {
          name: "reporteRecepcionKibana",
          path: "reportes-recepcion",
          component: lazyLoading("Recepcion/Pages/reporteRecepcionKibana"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA", "RECEPCION"],
          },
          children: [
            {
              name: "reporteCompras",
              path: "reporte-compras",
              default: true,
              component: lazyLoading("Recepcion/Reportes/reporteCompras"),
              meta: {
                permissions: ["ADMIN"],
              },
            },
            {
              name: "reportePreIngreso",
              path: "reporte-pre-ingreso",
              default: true,
              component: lazyLoading("Recepcion/Reportes/reportePreIngreso"),
              meta: {
                permissions: ["ADMIN", "RECEPCION", "BODEGA"],
              },
            },
            {
              name: "reporteDocumento",
              path: "reporte-documento",
              default: true,
              component: lazyLoading("Recepcion/Reportes/reporteDocumento"),
              meta: {
                permissions: ["ADMIN", "RECEPCION", "BODEGA"],
              },
            },
            {
              name: "reporteDocumentPdf",
              path: "reporte-documento-pdf",
              default: true,
              component: lazyLoading("Recepcion/Reportes/reporteDocumentPdf"),
              meta: {
                permissions: ["ADMIN", "RECEPCION", "BODEGA"],
              },
            },
          ],
        },
        {
          name: "productoPendiente",
          path: "producto-pendiente",
          component: lazyLoading("Recepcion/Pages/productoPendiente"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RECEPCION"],
          },
        },
      ],
    },
    {
      name: "marketing",
      path: "/marketing",
      component: AppLayout,
      children: [
        {
          name: "categoria",
          path: "categoria",
          component: lazyLoading("Marketing/Pages/categoria"),
          default: true,
          meta: {
            permissions: ["ADMIN", "MARKETING"],
          },
        },
        {
          name: "familia",
          path: "familia",
          component: lazyLoading("Marketing/Pages/familia"),
          default: true,
          meta: {
            permissions: ["ADMIN", "MARKETING"],
          },
        },
        {
          name: "precios",
          path: "precios",
          component: lazyLoading("Marketing/Pages/precios"),
          default: true,
          meta: {
            permissions: ["ADMIN", "PRECIO_MARKETING"],
          },
        },
        {
          name: "ofertas",
          path: "ofertas",
          component: lazyLoading("Marketing/Pages/ofertas"),
          default: true,
          meta: {
            permissions: ["ADMIN", "MARKETING"],
          },
        },
        {
          name: "reporteMarketing",
          path: "reporte-marketing",
          component: lazyLoading("Marketing/Pages/indexReportes"),
          default: true,
          meta: {
            permissions: ["ADMIN", "MARKETING"],
          },
          children: [
            {
              name: "topProductos",
              path: "top-productos",
              default: true,
              component: lazyLoading("Marketing/Pages/Reportes/topProductos"),
              meta: {
                permissions: ["ADMIN", "MARKETING"],
              },
            },
            {
              name: "reporteCallCenter",
              path: "reporte-call-center",
              default: true,
              component: lazyLoading(
                "Marketing/Pages/Reportes/reporteCallCenter"
              ),
              meta: {
                permissions: ["ADMIN", "MARKETING"],
              },
            },
          ],
        },
      ],
    },
    {
      name: "finanzaMiranda",
      path: "/finanzas",
      component: AppLayout,
      children: [
        {
          name: "cheques",
          path: "cheques",
          component: lazyLoading("Finanzas/Pages/cheques"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "convenioClientes",
          path: "convenio-clientes",
          component: lazyLoading("Finanzas/Pages/convenioClientes"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "notasCredito",
          path: "notas-de-credito",
          component: lazyLoading("Finanzas/Pages/notasCredito"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "clientesCredito",
          path: "clientes-credito",
          component: lazyLoading("Finanzas/Pages/clientesCredito"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "crearClienteCredito",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/finanzas/crear-cliente`;
          },
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "crearClienteCredito",
          path: "clientes-credito/estado-cuenta",
          component: lazyLoading("Finanzas/Pages/estadoCuentaClientes"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "finanzasListaProveedores",
          path: "proveedores",
          component: lazyLoading("Finanzas/Pages/listaProveedores"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "estadoCuentaProveedor",
          path: "proveedores/estado-cuenta",
          component: lazyLoading("Finanzas/Pages/estadoCuentaProveedor"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "listaDepositos",
          path: "depositos",
          component: lazyLoading("Finanzas/Pages/listaDepositos"),
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "costoVentas",
          path: "costo-ventas",
          component: lazyLoading("Finanzas/Pages/costoVentas"),
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "ventasAnual",
          path: "ventas-anual",
          component: lazyLoading("Finanzas/Pages/ventasAnual"),
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "consolidadoPeriodo",
          path: "consolidado-periodo",
          component: lazyLoading("Finanzas/Pages/consolidadoPeriodo"),
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
        {
          name: "presupuesto",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/finanzas/administrar-presupuesto`;
          },
          meta: {
            permissions: ["ADMIN", "FINANZAS"],
          },
        },
      ],
    },
    {
      name: "sucursalesMiranda",
      path: "/sucursales",
      component: AppLayout,
      children: [
        {
          name: "sucursales",
          path: "sucursales",
          component: lazyLoading("Sucursales/Pages/sucursales"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "appInventario",
          path: "app-inventario",
          component: lazyLoading("Sucursales/Pages/appInventario"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "verInventario",
          path: "ver-inventario",
          component: lazyLoading("Sucursales/Pages/verInventario"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
      ],
    },
    {
      name: "ventas",
      path: "/ventas",
      component: AppLayout,
      children: [
        {
          name: "historico-dte",
          path: "historico-dte",
          component: lazyLoading("Caja/Pages/historico"),
          meta: {
            permissions: ["ADMIN", "VENTAS"],
          },
        },
        {
          name: "nueva",
          path: "nueva",
          component: lazyLoading("ventas/Pages/Nueva"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "listarVentasV2",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/ventas/list`;
          },
          meta: {
            permissions: ["ADMIN", "VENTAS"],
          },
        },
        {
          name: "ventaV2",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/ventas/nueva`;
          },
          meta: {
            permissions: ["ADMIN", "VENTAS"],
          },
        },
        {
          name: "listarVentas",
          path: "listar-ventas",
          component: lazyLoading("ventas/Pages/listarVentas"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "despacho",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/bodega/despacho`;
          },
          meta: {
            permissions: ["ADMIN", "VENTAS"],
          },
        },
        {
          name: "carroVentas",
          path: "carro-ventas",
          component: lazyLoading("ventas/Pages/carroVentas"),
          default: true,
          meta: {
            permissions: ["ADMIN", "VENTAS"],
          },
        },
        {
          name: "verProducto",
          path: "ver-producto",
          component: lazyLoading("ventas/Pages/verProducto"),
          default: true,
          meta: {
            permissions: ["ADMIN", "VENTAS", "BODEGA"],
          },
        },
        {
          name: "indexReportes",
          path: "reportes",
          component: lazyLoading("ventas/Pages/indexReportes"),
          default: true,
          meta: {
            permissions: ["ADMIN", "VENTAS"],
          },
          children: [
            {
              name: "resumenVenta",
              path: "resumen-venta",
              default: true,
              component: lazyLoading("ventas/Pages/Reportes/resumenVentas"),
              meta: {
                permissions: ["ADMIN", "VENTAS"],
              },
            },
            {
              name: "reporteEncargos",
              path: "reporte-encargos",
              default: true,
              component: lazyLoading("ventas/Pages/Reportes/reporteEncargos"),
              meta: {
                permissions: ["ADMIN"],
              },
            },
            {
              name: "reportePagoAbono",
              path: "reporte-pago-abono",
              default: true,
              component: lazyLoading("ventas/Pages/Reportes/reportePagoAbono"),
              meta: {
                permissions: ["ADMIN"],
              },
            },
            {
              name: "ventasVsCompras",
              path: "ventas-vs-compras",
              default: true,
              component: lazyLoading("ventas/Pages/Reportes/ventasVsCompras"),
              meta: {
                permissions: ["ADMIN"],
              },
            },
          ],
        },
      ],
    },
    {
      name: "picking",
      path: "/picking",
      component: AppLayout,
      children: [
        {
          name: "listarPicking",
          path: "listar-picking",
          component: lazyLoading("Picking/Pages/listarPicking"),
          default: true,
          meta: {
            permissions: ["ADMIN", "PICKING", "BODEGA"],
          },
        },
        {
          name: "verPicking",
          path: "ver-picking",
          component: lazyLoading("Picking/Pages/verPicking"),
          default: true,
          meta: {
            permissions: ["ADMIN", "PICKING", "BODEGA"],
          },
        },
        {
          name: "reIngresoBodega",
          path: "ingreso-bodega",
          component: lazyLoading("Picking/Pages/reIngresoBodega"),
          default: true,
          meta: {
            permissions: ["ADMIN", "PICKING", "BODEGA"],
          },
        },
      ],
    },
    {
      name: "cajaMiranda",
      path: "/caja",
      component: AppLayout,
      children: [
        {
          name: "caja",
          path: "caja",
          component: lazyLoading("Caja/Pages/caja"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "pagar",
          path: "pagar",
          component: lazyLoading("Caja/Pages/pagar"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "historico",
          path: "historico",
          component: lazyLoading("Caja/Pages/historico"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "rendicion",
          path: "rendicion",
          component: lazyLoading("Caja/Pages/rendicion"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "verCaja",
          path: "ver-caja",
          component: lazyLoading("Caja/Pages/verCaja"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "retiroCaja",
          path: "retiro-caja",
          component: lazyLoading("Caja/Pages/retiroCaja"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "retiro",
          path: "retiro-caja",
          component: lazyLoading("Caja/Pages/retiroCaja"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "egresos",
          path: "egresos",
          component: lazyLoading("Caja/Pages/egresos"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "ingresos",
          path: "ingresos",
          component: lazyLoading("Caja/Pages/ingresos"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        {
          name: "cerrarCaja",
          path: "cerrar-caja",
          component: lazyLoading("Caja/Pages/cerrarCaja"),
          default: true,
          meta: {
            permissions: ["CAJA", "ADMIN"],
          },
        },
        //new cash Register
        {
          name: "nueva-caja",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/abrir-caja`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
        {
          name: "nuevo-historico-dte",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/historico`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
        {
          name: "nueva-rendicion",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/historico-cajas`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
        {
          name: "nuevo-retiro",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/retiro-caja`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
        {
          name: "nuevo-ingreso",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/ingresos`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
        {
          name: "nuevo-egreso",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/egresos`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
        {
          name: "nuevo-saldo-favor",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/cajas/saldo-favor`;
          },
          meta: {
            permissions: ["ADMIN", "CAJA"],
          },
        },
      ],
    },
    {
      name: "empaqueMiranda",
      path: "/empaque",
      component: AppLayout,
      children: [
        {
          name: "empaque",
          path: "empaque",
          component: lazyLoading("Empaque/Pages/empaque"),
          default: true,
          meta: {
            permissions: ["ADMIN", "EMPAQUE"],
          },
        },
        {
          name: "vouchers",
          path: "vouchers-empaque",
          component: lazyLoading("Empaque/Pages/vouchers"),
          default: true,
          meta: {
            permissions: ["ADMIN", "EMPAQUE"],
          },
        },
      ],
    },
    {
      name: "usuarios",
      path: "/usuarios",
      component: AppLayout,
      children: [
        {
          name: "listarUsuarios",
          path: "listar-usuarios",
          component: lazyLoading("Usuarios/usuarios"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
      ],
    },
    {
      name: "postVenta",
      path: "/post-venta",
      component: AppLayout,
      children: [
        {
          name: "devolucionCliente",
          path: "devolucion-cliente",
          component: lazyLoading("DevolucionCliente/Pages/devolucionCliente"),
          default: true,
          meta: {
            permissions: ["ADMIN", "POSTVENTA"],
          },
        },
        {
          name: "posventa",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/posventa/listar`;
          },
          meta: {
            permissions: ["ADMIN", "POSTVENTA"],
          },
        },
        {
          name: "verDevolucion",
          path: "ver-devolucion",
          component: lazyLoading("DevolucionCliente/Pages/verDevolucion"),
          default: true,
          meta: {
            permissions: ["ADMIN", "POSTVENTA"],
          },
        },
        {
          name: "historicoCliente",
          path: "historico-devolucion-cliente",
          component: lazyLoading("DevolucionCliente/Pages/historicoCliente"),
          default: true,
          meta: {
            permissions: ["ADMIN", "POSTVENTA"],
          },
        },
      ],
    },
    {
      name: "informatica",
      path: "/informatica",
      component: AppLayout,
      children: [
        {
          name: "solicitudRequerimientos",
          path: "solicitud-requerimientos",
          component: lazyLoading("Informatica/Pages/solicitud"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "crearRequermiento",
          path: "solicitud/crear",
          component: lazyLoading("Informatica/Pages/crearRequerimiento"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "detalleRequerimiento",
          path: "solicitud/detalle",
          component: lazyLoading("Informatica/Pages/detalleRequerimiento"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
        {
          name: "solicitud-ayuda",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/informatica/solicitud-ayuda`;
          },
          meta: {
            permissions: [
              "ADMIN",
              "COMPRAS",
              "PRODUCTO",
              "BODEGA",
              "RECEPCION",
              "MARKETING",
              "FINANZAS",
              "VENTAS",
              "CAJA",
              "EMPAQUE",
              "RRHH",
            ],
          },
        },
        {
          name: "administrar-solicitudes",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/informatica/admin-solicitudes`;
          },
          meta: {
            permissions: ["ADMIN"],
          },
        },
      ],
    },
    {
      name: "bodega",
      path: "/bodega",
      component: AppLayout,
      children: [
        {
          name: "bodega",
          path: "bodega",
          component: lazyLoading("Bodega/Pages/bodega"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "devoluciones",
          path: "devoluciones",
          component: lazyLoading("Bodega/Pages/devoluciones"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "generarGuias",
          path: "generar-guias",
          component: lazyLoading("Bodega/Pages/generarGuias"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "generarDevolucion",
          path: "generar-devolucion",
          component: lazyLoading("Bodega/Pages/generarDevolucion"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "pedidoEntreSucursales",
          path: "pedido-entre-sucursales",
          component: lazyLoading("Bodega/Pages/pedidoEntreSucursales"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "guiasTraslado",
          path: "guias-traslado",
          component: lazyLoading("Bodega/Pages/guiasTraslado"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "ajusteStock",
          path: "ajuste-stock",
          component: lazyLoading("Bodega/Pages/ajusteStock"),
          default: true,
          meta: {
            permissions: ["ADMIN", "AJUSTE_STOCK"],
          },
        },
        {
          name: "inventario",
          path: "inventario",
          component: lazyLoading("Bodega/Pages/inventario"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "inventarioSucursal",
          path: "inventario-sucursal",
          component: lazyLoading("Bodega/Pages/inventarioSucursal"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "mapeoBodega",
          path: "mapeo-bodega",
          component: lazyLoading("Bodega/Pages/mapeoBodega"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "empaque-despacho",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/bodega/empaque-despacho`;
          },
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "credit-memo/list",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/bodega/credit-memo/list`;
          },
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
        {
          name: "new-inventory",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/bodega/inventario`;
          },
          meta: {
            permissions: ["ADMIN", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "devolucionesGeneradas",
          path: "devoluciones-generadas",
          component: lazyLoading("Bodega/Pages/devolucionesGeneradas"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA", "RECEPCION"],
          },
        },
        {
          name: "reportesProductos",
          path: "reportes",
          component: lazyLoading("Bodega/Pages/reportesProductos"),
          default: true,
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
          children: [
            {
              name: "reporteAjustes",
              path: "reporte-ajuste",
              default: true,
              component: lazyLoading("Bodega/Reportes/reporteAjustes"),
              meta: {
                permissions: ["ADMIN", "BODEGA"],
              },
            },
            {
              name: "reporteMovimiento",
              path: "reporte-movimiento",
              default: true,
              component: lazyLoading("Bodega/Reportes/reporteMovimiento"),
              meta: {
                permissions: ["ADMIN", "BODEGA"],
              },
            },
            {
              name: "reporteGrupoProveedor",
              path: "reporte-grupo",
              default: true,
              component: lazyLoading("Bodega/Reportes/reporteGrupoProveedor"),
              meta: {
                permissions: ["ADMIN"],
              },
            },
          ],
        },
        {
          name: "registroUbicaciones",
          path: "historico-ubicaciones",
          component: lazyLoading("Bodega/RegistroUbicaciones/historico"),
          meta: {
            permissions: ["ADMIN", "BODEGA"],
          },
        },
      ],
    },
    {
      name: "RecursosHumanos",
      path: "/recursos-humanos",
      component: AppLayout,
      children: [
        {
          name: "trabajadores",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/trabajadores`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "admin-cargos",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/administrar-cargos`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "mantenedor-comisiones",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/mantenedor-comisiones`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "periodo-comisiones",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/comisiones`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },

        {
          name: "comisiones",
          path: "comisiones",
          component: lazyLoading("RecursosHumanos/Pages/comisiones"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "verComision",
          path: "periodo",
          component: lazyLoading("RecursosHumanos/Pages/verComision"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "admin-vacaciones",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/administrar-vacaciones`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "asistencia",
          path: "asistencia",
          component: lazyLoading("RecursosHumanos/Pages/asistencia"),
          default: true,
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "rrhh-trabajadores",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/trabajadores`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "rrhh-ingresar-trabajador",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/crear-trabajador`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
        {
          name: "usuarios",
          path: "frontend v3",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV3_URL}/#/rrhh/usuarios`;
          },
          meta: {
            permissions: ["ADMIN", "RRHH"],
          },
        },
      ],
    },
    {
      name: "Cliente",
      path: "/cliente",
      component: AppLayout,
      children: [
        {
          name: "HistoricoCliente",
          path: "historico-cliente",
          component: lazyLoading("Cliente/Pages/HistoricoCliente"),
          default: true,
          meta: {
            permissions: ["ADMIN", "FINANZAS", "RRHH"],
          },
        },
      ],
    },
    {
      name: "main",
      path: "/main",
      component: AppLayout,
      children: [
        {
          name: "main",
          path: "reportes",
          component: lazyLoading("Reportes/Pages/main"),
          default: true,
          meta: {
            permissions: ["ADMIN", "REPORTE_RESUMEN_VENTA"],
          },
        },
        {
          name: "reportesBi",
          path: "reportes-power-bi",
          component: lazyLoading("Reportes/Pages/powerBi"),
          default: true,
          meta: {
            permissions: ["ADMIN"],
          },
        },
      ],
    },
    {
      name: "permisoVentas",
      path: "/permiso-ventas",
      component: AppLayout,
      children: [
        {
          name: "solicitudes",
          path: "solicitudes",
          component: lazyLoading("PermisoVentas/Pages/solicitudes"),
          default: true,
          meta: {
            permissions: ["ADMIN", "POSTVENTA"],
          },
        },
      ],
    },
    {
      name: "asesoria",
      path: "/asesoria",
      component: AppLayout,
      children: [
        {
          name: "epp-acuerdos",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/asesoria/pee-agreement`;
          },
          meta: {
            permissions: [
              "ADMIN",
              "ASESORIA",
              "PARITARIO",
              "PREVENCION",
              "RRHH",
            ],
          },
        },
        {
          name: "epp-management",
          path: "frontend v4",
          beforeEnter() {
            location.href = `${process.env.VUE_APP_FRONTENDV4_URL}/#/asesoria/pee-items`;
          },
          meta: {
            permissions: [
              "ADMIN",
              "ASESORIA",
              "PARITARIO",
              "PREVENCION",
              "RRHH",
            ],
          },
        },
      ],
    },

    {
      name: "Admin",
      path: "/admin",
      component: AppLayout,
      children: [
        {
          name: "dashboard",
          path: "dashboard",
          component: lazyLoading("dashboard/Dashboard"),
          default: true,
          meta: {
            isPublic: true,
          },
        },
        {
          name: "progress-bars",
          path: "progress-bars",
          component: lazyLoading("statistics/progress-bars/ProgressBars"),
          meta: {
            wikiLink:
              "https://github.com/epicmaxco/vuestic-admin/wiki/Progress-Bars",
          },
        },
        {
          name: "forms",
          path: "forms",
          component: EmptyParentComponent,
          children: [
            {
              name: "form-elements",
              path: "form-elements",
              component: lazyLoading("forms/form-elements/FormElements"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/inputs",
              },
            },
            {
              name: "form-wizards",
              path: "form-wizards",
              component: lazyLoading("forms/form-wizard/FormWizard"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Wizards",
              },
            },
            {
              name: "medium-editor",
              path: "medium-editor",
              component: lazyLoading("forms/medium-editor/MediumEditor"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Medium-Editor",
              },
            },
          ],
        },
        {
          name: "tables",
          path: "tables",
          component: lazyLoading("tables/Table"),
          meta: {
            wikiLink: "https://github.com/epicmaxco/vuestic-admin/wiki/Tables",
          },
        },
        {
          name: "ui",
          path: "ui",
          component: EmptyParentComponent,
          children: [
            {
              name: "typography",
              path: "typography",
              component: lazyLoading("ui/typography/Typography"),
            },
            {
              name: "buttons",
              path: "buttons",
              component: lazyLoading("ui/buttons/Buttons"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Buttons",
              },
            },
            {
              name: "color-pickers",
              path: "color-pickers",
              component: lazyLoading("ui/color-pickers/ColorPickers"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Color-Pickers",
              },
            },
            {
              name: "timelines",
              path: "timelines",
              component: lazyLoading("ui/timelines/Timelines"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Timelines",
              },
            },
            {
              name: "dropdowns",
              path: "dropdowns",
              component: lazyLoading("ui/dropdowns/Dropdowns"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Dropdowns",
              },
            },
            {
              name: "notifications",
              path: "notifications",
              component: lazyLoading("ui/notifications/Notifications"),
            },
            {
              path: "icons",
              component: lazyLoading("ui/icons/Icons"),
              children: [
                {
                  name: "icon-sets",
                  path: "", // Default route
                  component: lazyLoading("ui/icons/SetsList"),
                },
                {
                  name: "icon-set",
                  path: ":name",
                  component: lazyLoading("ui/icons/IconSet"),
                  props: true,
                },
              ],
            },
            {
              name: "spinners",
              path: "spinners",
              component: lazyLoading("ui/spinners/Spinners"),
            },
            {
              name: "grid",
              path: "grid",
              component: lazyLoading("ui/grid/Grid"),
            },
            {
              name: "modals",
              path: "modals",
              component: lazyLoading("ui/modals/Modals"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Modals",
              },
            },
            {
              name: "cards",
              path: "cards",
              component: lazyLoading("ui/cards/Cards"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Cards",
              },
            },
            {
              name: "file-upload",
              path: "file-upload",
              component: lazyLoading("ui/file-upload/FileUpload"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/File-Upload",
              },
            },
            {
              name: "tags",
              path: "tags",
              component: lazyLoading("ui/tags/Tags"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Tags",
              },
            },
            {
              name: "tree-view",
              path: "tree-view",
              component: lazyLoading("ui/tree-view/TreeView"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Tree-view",
              },
            },
            {
              name: "collapse",
              path: "collapse",
              component: lazyLoading("ui/collapse/Collapse"),
            },
            {
              name: "filters",
              path: "filters",
              component: lazyLoading("ui/filters/Filters"),
            },
          ],
        },
        {
          name: "extra",
          path: "extra",
          component: lazyLoading("extra/Extra"),
          meta: {
            wikiLink: "https://github.com/epicmaxco/vuestic-admin/wiki/Tabs",
          },
        },
        {
          name: "maps",
          path: "maps",
          component: EmptyParentComponent,
          children: [
            {
              name: "google-maps",
              path: "google-maps",
              component: lazyLoading("maps/google-maps/GoogleMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "yandex-maps",
              path: "yandex-maps",
              component: lazyLoading("maps/yandex-maps/YandexMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "leaflet-maps",
              path: "leaflet-maps",
              component: lazyLoading("maps/leaflet-maps/LeafletMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "bubble-maps",
              path: "bubble-maps",
              component: lazyLoading("maps/bubble-maps/BubbleMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
            {
              name: "line-maps",
              path: "line-maps",
              component: lazyLoading("maps/line-maps/LineMapsPage"),
              meta: {
                wikiLink:
                  "https://github.com/epicmaxco/vuestic-admin/wiki/Maps",
              },
            },
          ],
        },
        {
          name: "pages",
          path: "/pages",
          component: EmptyParentComponent,
          children: [
            {
              name: "404-pages",
              path: "404-pages",
              component: lazyLoading("pages/404-pages/404PagesPage"),
              meta: {
                isPublic: true,
                permissions: ["ADMIN", "USUARIO"],
              },
            },
          ],
        },
      ],
    },
  ],
});
